import { c as _c } from "react/compiler-runtime";
import Skeleton from 'react-loading-skeleton';
import styles from './hash-tabs-navigation-skeleton.module.scss';
export const TabPanelSkeleton = () => {
  const $ = _c(6);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Skeleton className={styles["tab-panel-skeleton__heading"]} />;
    t1 = <Skeleton className={styles["tab-panel-skeleton__text"]} count={1.8} />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className={styles["tab-panel-skeleton__links"]}><Skeleton className={styles["tab-panel-skeleton__link"]} /><Skeleton className={styles["tab-panel-skeleton__link"]} /></div>;
    t3 = <Skeleton className={styles["tab-panel-skeleton__text"]} count={1.5} />;
    t4 = <Skeleton className={styles["tab-panel-skeleton__text"]} count={6} />;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className={styles["tab-panel-skeleton"]}>{t0}{t1}{t2}{t3}{t4}<div className={styles["tab-panel-skeleton__button-container"]}><Skeleton className={styles["tab-panel-skeleton__button"]} /></div></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
};
export const TabsNavigationSkeleton = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={styles["tabs-navigation-skeleton__menu-button-container"]}><Skeleton className={styles["tabs-navigation-skeleton__menu-button"]} /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className={styles["tabs-navigation-skeleton"]}>{t0}<div className={styles["tabs-navigation-skeleton__list"]}>{[1, 2, 3, 4, 5, 6, 7].map(_temp)}</div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export const HashTabsNavigationSkeleton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={styles["hash-tabs-navigation-skeleton"]}><TabsNavigationSkeleton /><TabPanelSkeleton /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
function _temp(key) {
  return <Skeleton className={styles["tabs-navigation-skeleton__skeleton-item"]} key={key} />;
}